import qs from 'qs'
import { axios } from '@/utils/request'

const unitApi = {
  //主单位表
  addUnit: '/api/1/expertmain/unit/addUnit.json',
  editUnit: '/api/1/expertmain/unit/editUnit.json',
  getUnit: '/api/1/expertmain/unit/getUnit.json',
  delUnit: '/api/1/expertmain/unit/delUnit.json',
  queryUnit: '/api/1/expertmain/unit/queryUnit.json',
  queryUnitVo: '/api/1/expertmain/unit/queryUnitVo.json',
  //子单位
  addUnitItem: '/api/1/expertmain/unit/addUnitItem.json',
  delUnitItem: '/api/1/expertmain/unit/delUnitItem.json',
  queryUnitItem: '/api/1/expertmain/unit/queryUnitItem.json',
}

//构建请求
/**
 * 添加主单位
 * @param unit
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const AddUnit = (unit) => axios.post(unitApi.addUnit, qs.stringify(unit))

/**
 * 编辑主单位
 * @param unit
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const EditUnit = (unit) => axios.post(unitApi.editUnit, qs.stringify(unit))

/**
 * 删除主单位
 * @param id
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const DelUnit = (id) => axios.post(unitApi.delUnit, qs.stringify({ id }))
/**
 * 分页查看单位数据
 * @param unit
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const QueryUnit = (unit) => axios.get(unitApi.queryUnit, { params: { ...unit } })

/**
 * 查看单位数据
 * @param id
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetUnit = (id) => axios.get(unitApi.getUnit, { params: { id } })

/**
 * 分页查看单位数据
 * @param unitVo
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const QueryUnitVo = (unitVo) => axios.get(unitApi.queryUnitVo, { params: { ...unitVo } })

/**
 * 删除子单位
 * @param id
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const DelUnitItem = (id) => axios.post(unitApi.delUnitItem, qs.stringify({ id }))
/**
 * 分页查看子单位数据
 * @param unitItem
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const QueryUnitItem = (unitItem) => axios.get(unitApi.queryUnitItem, { params: { ...unitItem } })

/**
 * 添加子单位
 * @param itemUnit
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const AddUnitItem = (itemUnit) => axios.post(unitApi.addUnitItem, qs.stringify(itemUnit))


